import { useTranslation } from 'react-i18next';
import { IconButton, TitleBar } from '@livechat/ui-kit';
import { PropTypes } from 'prop-types';
import { ENG, ESP, LANGUAGE_SELECTION } from '../../../Constants';
import { CommonStyles } from '../balance-cancellation/CommonStyles';
import { API_CONFIG } from '../../../config/apiconfig';

const useCommonStyles = CommonStyles();

const ChatHeader = (props) => {
  const CommoncssStyles = useCommonStyles();

  const { t } = useTranslation();
  const { englishBot, changeLanguage, minimize, closeEvent, baseURL } = props;
  const imageBaseURL = baseURL?.IMAGE_BASE_URL;
  const minimizeClicked = () => {
    if ('parentIFrame' in window) {
      window.parentIFrame.size(100, 140);
    }
    minimize();
  };
  return (
    <TitleBar
      leftIcons={[
        <div
          style={{
            display: 'inline-flex',
          }}
          className="leftIcons"
          key="div-wrapper"
        >
          <IconButton
            key="minimize"
            className={CommoncssStyles.chat_header_icon}
            aria-label={LANGUAGE_SELECTION}
            onClick={changeLanguage}
            tabIndex="100"
            data-testid="changeLanguage_testid"
          >
            {imageBaseURL && (
              <img
                src={`${imageBaseURL}${API_CONFIG.WORLD_ICON}`}
                alt="oriental language icon"
                width="17"
                height="17"
                className={CommoncssStyles.chat_head_img}
              />
            )}
            <span className="languageLink">{englishBot ? ESP : ENG}</span>
          </IconButton>
        </div>,
      ]}
      rightIcons={[
        <div className={CommoncssStyles.chat_header_right_icon} key="div">
          <IconButton
            key="minimize"
            onClick={minimizeClicked}
            style={{
              padding: '0',
              paddingBottom: '8px',
              marginRight: '12px',
            }}
            aria-label="minimize"
            data-testid="minClickbtn_testid"
            tabIndex="106"
          >
            <span
              aria-hidden="true"
              style={{
                display: 'inline-block',
                width: '14px',
                height: '2px',
                backgroundColor: '#000000',
              }}
            />
          </IconButton>
          <IconButton
            key="close"
            className={CommoncssStyles.icon_button}
            onClick={closeEvent}
            data-testid="closeevent_testid"
            aria-label="close"
            tabIndex="107"
          >
            {imageBaseURL && (
              <img
                src={`${imageBaseURL}${API_CONFIG.CROSS_ICON}`}
                alt="close"
                width="20"
                height="20"
              />
            )}
          </IconButton>
        </div>,
      ]}
      title={[
        <h1 className="titleHeading" key="title">
          {t('Chat')} <sup className={CommoncssStyles.sup_design}>Beta</sup>
        </h1>,
      ]}
    />
  );
};

ChatHeader.propTypes = {
  englishBot: PropTypes.bool,
  changeLanguage: PropTypes.func,
  minimize: PropTypes.func,
  closeEvent: PropTypes.func,
  baseURL: PropTypes.object,
};
export default ChatHeader;
